<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-komoditas" lazy-validation>
        <h3 style="margin: 0% auto;"><b>Tambahkan Pesanan Pengiriman Baru</b></h3>
        <small>Kontrak > {{kodePenjualan}} > Tambahkan Pesanan Pengiriman</small>
        <v-layout row wrap>

            <!-- Bagian Umum -->
            <v-flex xs6>
                <v-subheader><h4><b>Bagian Umum</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-hand-holding-usd" label="Tipe Pengiriman Pesanan" name="jenisPengirimanPesanan" v-model="jenisPengirimanPesanan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualan" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Perantara" name="kontakPerantara" v-model="kontakPerantara" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <!-- Penjelasan Komoditas Kontrak -->
            <v-flex xs6>
                <v-subheader><h4><b>Penjelasan Komoditas Kontrak</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <div class="layout row border">
                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Penjual</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{penjual}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b>{{entitasPenjual}}</b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPenjual}}</b></p>
                    </div>                

                    <div class="layout column">
                        <p class="flex my-1 text-xs-left"><b>Pembeli</b></p>
                        <p class="flex my-1 text-xs-left">Nama: <b>{{pembeli}}</b></p>
                        <p class="flex my-2 text-xs-left">Entitas: <b>{{entitasPembeli}}</b></p>
                        <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPembeli}}</b></p>
                    </div>                
                </div>
            </v-flex>

            <!-- Pelaku Usaha -->
            <v-flex xs6>
                <v-subheader><h4><b>Pelaku Usaha</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Pembeli (Pelanggan)" name="pembeli" v-model="pembeli" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Pembeli (Pelanggan)" name="kontakPembeli" v-model="kontakPembeli" type="number" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                prepend-icon="fas fa-shipping-fast"
                v-model="penyediaJasaPengiriman"
                :items="tipePenyediaJasaPengiriman"
                label="Pilih Penyedia Jasa Pengiriman"
                ></v-select>
                <small v-if="!isPenyediaJasaPengiriman" class="alert">Pilih Penyedia Jasa Pengiriman</small>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="phone" label="Kontak Penyedia Jasa Pengiriman" name="kontakPenyediaJasaPengiriman" v-model="kontakPenyediaJasaPengiriman">
                </v-text-field>
                <small v-if="!isKontakPenyediaJasaPengiriman" class="alert">masukan Kontak Penyedia Jasa Pengiriman</small>
            </v-flex>

            <!-- Penjelasan Pesanan Pengiriman -->
            <v-flex xs6>
                <v-subheader><h4><b>Penjelasan Pesanan Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-apple-alt" label="Komoditas" name="komoditas" v-model="komoditas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-balance-scale" label="Tingkat Kualitas" name="kualitas" v-model="kualitas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-calendar" label="Musim" name="musim" v-model="musim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-balance-scale" label="Kuantitas" name="kuantitas" v-model="kuantitas" :suffix="'/' + unitKuantitas" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <!-- Penjemputan -->
            <v-flex xs12>
                <v-subheader><h4><b>Penjemputan</b></h4></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                class="pr-2"
                ref="tanggalMulaiPenjemputan"
                lazy
                :close-on-content-click="false"
                v-model="tanggalMulaiPenjemputanMenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-22"
                max-width="290px"
                :return-value.sync="tanggalMulaiPenjemputan"
                >
                <v-text-field
                    slot="activator"
                    label="Tanggal Mulai Penjemputan"
                    v-model="tanggalMulaiPenjemputan"
                    prepend-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker v-model="tanggalMulaiPenjemputan" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="tanggalMulaiPenjemputanMenu = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.tanggalMulaiPenjemputan.save(tanggalMulaiPenjemputan)">OK</v-btn>
                </v-date-picker>
                </v-menu>
                <small v-if="!isTanggalMulaiPenjemputan" class="alert">Pilih Tanggal Mulai Penjemputan</small>
            </v-flex>

            <v-flex sm6 lg6>
                <v-menu
                ref="waktuMulaiPenjemputan"
                lazy
                :close-on-content-click="false"
                v-model="waktuMulaiPenjemputanMenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-bottom="-24"
                max-width="290px"
                :return-value.sync="waktuMulaiPenjemputan"
                >
                <v-text-field
                    slot="activator"
                    label="Waktu Mulai Penjemputan"
                    v-model="waktuMulaiPenjemputan"
                    prepend-icon="access_time"
                    readonly
                ></v-text-field>
                <v-time-picker v-model="waktuMulaiPenjemputan">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="waktuMulaiPenjemputanMenu = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.waktuMulaiPenjemputan.save(waktuMulaiPenjemputan)">OK</v-btn>                
                </v-time-picker>
                </v-menu>
                <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
                <br>
                <small v-if="!isWaktuMulaiPenjemputan" class="alert">Pilih Waktu Mulai Penjemputan</small>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Pengirim" name="pengirim" v-model="pengirim" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Penjemputan" name="lokasiPenjemputan" v-model="lokasiPenjemputan">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan Penjemputan" name="kodePenjualanPenjemputan" v-model="kodePenjualanPenjemputan" maxlength="9">
                </v-text-field>
                <small v-if="!isKodePenjualanPenjemputan" class="alert">Kode Penjualan Penjemputan Harus 9 Karakter</small>
            </v-flex>

            <!-- Pengiriman -->
            <v-flex xs12>
                <v-subheader><h4><b>Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Tanggal Mulai Pengiriman"
                    v-model="tanggalMulaiPengiriman"
                    prepend-icon="event"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Waktu Mulai Pengiriman"
                    v-model="waktuMulaiPengiriman"
                    prepend-icon="access_time"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="person" label="Nama Penerima" name="penerima" v-model="penerima" disabled append-icon="lock">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Penjemputan" name="lokasiPengiriman" v-model="lokasiPengiriman">
                </v-text-field>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan Pengiriman" name="kodePenjualanPengiriman" v-model="kodePenjualanPengiriman" maxlength="9">
                </v-text-field>
                <small v-if="!isKodePenjualanPengiriman" class="alert">Kode Penjualan Pengiriman Harus 9 Karakter</small>
            </v-flex>

            <!-- Kontrak Pengiriman -->
            <v-flex xs12>
                <v-subheader><h4><b>Kontrak Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-select
                prepend-icon="fas fa-hand-holding-usd"
                v-model="faktur"
                :items="tipeFaktur"
                label="Pilih Faktur"
                ></v-select>
                <small v-if="!isFaktur" class="alert">Pilih Tipe Faktur</small>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Jangka Tanggal Akhir Pembayaran"
                    v-model="tanggalJatuhTempo"
                    prepend-icon="event"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex>

            <v-flex sm6 lg6>
                <v-text-field
                    slot="activator"
                    label="Jangka Waktu Akhir Pembayaran"
                    v-model="waktuJatuhTempo"
                    prepend-icon="access_time"
                    append-icon="lock"
                    readonly
                    disabled
                ></v-text-field>
            </v-flex> 

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-crosshairs" label="Perkiraan Jarak Tempuh" name="jarakTempuh" v-model="jarakTempuh" type="number" suffix="Km">
                </v-text-field>
                <small v-if="!isJarakTempuh" class="alert">Masukan Perkiraan Jarak Tempuh</small>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-crosshairs" label="Perkiraan Waktu Perjalanan" name="waktuPerjalanan" v-model="waktuTempuh" suffix="Jam" type="number">
                </v-text-field>
                <small v-if="!isWaktuTempuh" class="alert">Masukan Perkiraan Waktu Tempuh</small>
            </v-flex>

            <v-flex lg12 sm12>
                <v-text-field prepend-icon="fas fa-money" label="Nilai Komisi" name="nilaiKomisi" v-model="nilaiKomisi" prefix="Rp. " suffix=".00" type="number">
                </v-text-field>
                <small v-if="!isNilaiKomisi" class="alert">Masukan Nilai Komisi. Contoh: 10000000</small>
            </v-flex>

            <!-- Kondisi Kontrak Pengiriman -->
            <v-flex xs6>
                <v-subheader><h4><b>Kondisi Kontrak Pengiriman</b></h4></v-subheader>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea prepend-icon="fas fa-file-contract" label="Kondisi Kontrak Umum" name="kontrakUmum" v-model="kondisiUmum" outline disabled append-icon="lock">
                </v-textarea>
            </v-flex>

            <v-flex lg12 sm12>
                <v-textarea prepend-icon="fas fa-file-contract" label="Kondisi Kontrak Khusus" name="kontrakKhusus" v-model="kondisiKhusus" outline disabled append-icon="lock">
                </v-textarea>
            </v-flex>

        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="secondary" @click="saveTemplate">Simpan Template</v-btn>
          <v-btn color="primary" form="tambahkan-komoditas" @click="getPesananPengiriman" :disabled="!isComplete">Lanjutkan dan Ulas</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: '',
    modal: false ,

    // Bagian Umum 
    kodePenjualan: localStorage.kontrakKodePenjualan,
    komoditas: localStorage.kontrakKomoditas,
    dokumen: localStorage.kontrakDokumen,

    // Pelaku Usaha
    penjual: localStorage.kontrakPenjual,
    entitasPenjual: localStorage.kontrakEntitasPenjual,
    kontakPenjual: localStorage.kontrakKontakPenjual,
    emailPenjual: localStorage.kontrakEmailPenjual,
    faxPenjual: localStorage.kontrakFaxPenjual,
    alamatJalanPenjual: localStorage.kontrakAlamatJalanPenjual,
    alamatKelurahanPenjual: localStorage.kontrakAlamatKelurahanPenjual,
    alamatKecamatanPenjual: localStorage.kontrakAlamatKecamatanPenjual,
    alamatKabupatenPenjual: localStorage.kontrakAlamatKabupatenPenjual,
    alamatKotaPenjual: localStorage.kontrakAlamatKotaPenjual,
    alamatProvinsiPenjual: localStorage.kontrakAlamatProvinsiPenjual,
    alamatKodePosPenjual: localStorage.kontrakAlamatKodePosPenjual,

    pembeli: localStorage.kontrakPembeli,
    entitasPembeli: localStorage.kontrakEntitasPembeli,
    kontakPembeli: localStorage.kontrakKontakPembeli,
    emailPembeli: localStorage.kontrakEmailPembeli,
    faxPembeli: localStorage.kontrakFaxPembeli,
    alamatJalanPembeli: localStorage.kontrakAlamatJalanPembeli,
    alamatKelurahanPembeli: localStorage.kontrakAlamatKelurahanPembeli,
    alamatKecamatanPembeli: localStorage.kontrakAlamatKecamatanPembeli,
    alamatKabupatenPembeli: localStorage.kontrakAlamatKabupatenPembeli,
    alamatKotaPembeli: localStorage.kontrakAlamatKotaPembeli,
    alamatProvinsiPembeli: localStorage.kontrakAlamatProvinsiPembeli,
    alamatKodePosPembeli: localStorage.kontrakAlamatKodePosPembeli,

    // Penjelasan Kontrak
    jenisKontrak: localStorage.kontrakJenisKontrak,
    kuantitas: localStorage.kontrakKuantitas,
    unitKuantitas: localStorage.kontrakUnitKuantitas,
    kualitas: localStorage.kontrakKualitas,
    hargaKomoditas: localStorage.kontrakHargaKomoditas,
    tempatPembayaran: localStorage.kontrakTempatPembayaran,
    musim: localStorage.kontrakMusim,
    jalurPengiriman: localStorage.kontrakJalurPengiriman,
    skalaPembayaran: localStorage.kontrakSkalaPembayaran,
    batasTanggalPembayaran: localStorage.kontrakBatasTanggalPembayaran,
    batasWaktuPembayaran: localStorage.kontrakBatasWaktuPembayaran,
    toleransi: localStorage.kontrakToleransi,
    daerahPemasaran: localStorage.kontrakDaerahPemasaran,
    provinsiPemasaran: localStorage.kontrakProvinsiPemasaran, 

    // Rincian Pengiriman
    pengirim: localStorage.kontrakPengirim,
    kontakPengirim: localStorage.kontrakKontakPengirim,
    lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
    alamatJalanPenjemputan: localStorage.kontrakAlamatJalanPenjemputan,
    alamatKelurahanPenjemputan: localStorage.kontrakAlamatKelurahanPenjemputan,
    alamatKecamatanPenjemputan: localStorage.kontrakAlamatKecamatanPenjemputan,
    alamatKabupatenPenjemputan: localStorage.kontrakAlamatKabupatenPenjemputan,
    alamatKotaPenjemputan: localStorage.kontrakAlamatKotaPenjemputan,
    alamatProvinsiPenjemputan: localStorage.kontrakAlamatProvinsiPenjemputan,
    alamatKodePosPenjemputan: localStorage.kontrakAlamatKodePosPenjemputan,

    penerima: localStorage.kontrakPenerima,
    kontakPenerima: localStorage.kontrakKontakPenerima,
    lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
    alamatJalanPengiriman: localStorage.kontrakAlamatJalanPengiriman,
    alamatKelurahanPengiriman: localStorage.kontrakAlamatKelurahanPengiriman,
    alamatKecamatanPengiriman: localStorage.kontrakAlamatKecamatanPengiriman,
    alamatKabupatenPengiriman: localStorage.kontrakAlamatKabupatenPengiriman,
    alamatKotaPengiriman: localStorage.kontrakAlamatKotaPengiriman,
    alamatProvinsiPengiriman: localStorage.kontrakAlamatProvinsiPengiriman,  
    alamatKodePosPengiriman: localStorage.kontrakAlamatKodePosPengiriman,

    // Detail Pengiriman
    tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
    waktuMulaiPengiriman: localStorage.kontrakWaktuMulaiPengiriman,
    tanggalBerakhirPengiriman: localStorage.kontrakTanggalBerakhirPengiriman,
    waktuBerakhirPengiriman: localStorage.kontrakWaktuBerakhirPengiriman,

    // Penjelasan Barang
    jenisPengepakan: localStorage.kontrakJenisPengepakan,

    // Kondisi Kontrak
    kondisiUmum: localStorage.kontrakKondisiUmum,
    kondisiKhusus: localStorage.kontrakKondisiKhusus,

    // Penilaian Kontrak
    nilai: localStorage.kontrakNilai,
    maxNilai: localStorage.kontrakMaxNilai,
    tanggalJatuhTempo: localStorage.kontrakTanggalJatuhTempo,
    waktuJatuhTempo: localStorage.kontrakWaktuJatuhTempo,

    // Usaha Pedagang Perantara
    jenisPembayaran: localStorage.kontrakJenisPembayaran,

    // Administrasi
    invoicing: localStorage.kontrakInvoicing,
    perantara: localStorage.kontrakPerantara,
    entitasPerantara: localStorage.kontrakEntitasPerantara,
    kontakPerantara: localStorage.kontrakKontakPerantara,
    catatanPedagang: localStorage.kontrakCatatanPedagang,

    // Sistem
    kontrakAktif: localStorage.kontrakActiveCurrentDate,
    kontrakId: localStorage.kontrakID,
    komoditasPesananPengirimanStatus: localStorage.komoditasPesananPengiriman,  
    komoditasPesananPengirimanAktif: localStorage.komoditasPesananPengirimanAktif,  

    // Komoditas
    jenisPengirimanPesanan: 'Penjual ke Pembeli',
    penyediaJasaPengiriman: '',
    tipePenyediaJasaPengiriman: [
        'Baraka Sarana Tama',
        'Rajasa Trans',
        'Nusa Dharma Ekspresindo',
    ], 
    kontakPenyediaJasaPengiriman: '',

    tanggalMulaiPenjemputanMenu: false,
    tanggalMulaiPenjemputan: '',
    waktuMulaiPenjemputanMenu: false,
    waktuMulaiPenjemputan: '',
    kodePenjualanPenjemputan: '',
    kodePenjualanPengiriman: '',

    faktur: '',
    tipeFaktur: [
        'Penyedia Pengiriman ke Pelanggan',
    ], 
    jarakTempuh: '',
    waktuTempuh: '',
    nilaiKomisi: '',

  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },

    // Form Check
    
    isComplete(){
        return (this.penyediaJasaPengiriman) && (this.kontakPenyediaJasaPengiriman && this.kontakPenyediaJasaPengiriman >= 0 && this.kontakPenyediaJasaPengiriman.length >= 8) && (this.tanggalMulaiPenjemputan) && (this.waktuMulaiPenjemputan) && (this.kodePenjualanPenjemputan && this.kodePenjualanPenjemputan.length == 9) && (this.kodePenjualanPengiriman && this.kodePenjualanPengiriman.length == 9) && (this.faktur) && (this.jarakTempuh && this.jarakTempuh >= 0) && (this.waktuTempuh && this.waktuTempuh >= 0) && (this.nilaiKomisi && this.nilaiKomisi >= 0);
    },

    // Pelaku Usaha 

    isPenyediaJasaPengiriman(){
        return (this.penyediaJasaPengiriman);
    },

    isKontakPenyediaJasaPengiriman (){
        return (this.kontakPenyediaJasaPengiriman && this.kontakPenyediaJasaPengiriman >= 0 && this.kontakPenyediaJasaPengiriman.length >= 8);
    },

    // Penjemputan

    isTanggalMulaiPenjemputan (){
        return (this.tanggalMulaiPenjemputan);
    },

    isWaktuMulaiPenjemputan (){
        return (this.waktuMulaiPenjemputan);
    },

    isKodePenjualanPenjemputan (){
        return (this.kodePenjualanPenjemputan && this.kodePenjualanPenjemputan.length == 9);
    },

    // Pengiriman

    isKodePenjualanPengiriman (){
        return (this.kodePenjualanPengiriman && this.kodePenjualanPengiriman.length == 9);
    },

    // Kontrak Pengiriman

    isFaktur (){
        return (this.faktur);
    },

    isJarakTempuh (){
        return (this.jarakTempuh && this.jarakTempuh >= 0);
    },

    isWaktuTempuh (){
        return (this.waktuTempuh && this.waktuTempuh >= 0);
    },

    isNilaiKomisi (){
        return (this.nilaiKomisi && this.nilaiKomisi >= 0);
    },

  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_KOMODITAS');
      // return '/pemerintah';
    },

    saveTemplate(){
        //   window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getPesananPengiriman (){
        // Komoditas
        localStorage.komoditasJenisPengirimanPesanan = this.jenisPengirimanPesanan,
        localStorage.komoditasPenyediaJasaPengiriman = this.penyediaJasaPengiriman,
        localStorage.komoditasKontakPenyediaJasaPengiriman = this.kontakPenyediaJasaPengiriman,
        localStorage.komoditasTanggalMulaiPenjemputan = moment(this.tanggalMulaiPenjemputan).format('DD-MM-YYYY')
        localStorage.komoditasWaktuMulaiPenjemputan = this.waktuMulaiPenjemputan,
        localStorage.komoditasKodePenjualanPenjemputan = this.kodePenjualanPenjemputan,
        localStorage.komoditasKodePenjualanPengiriman = this.kodePenjualanPengiriman,
        localStorage.komoditasFaktur = this.faktur,
        localStorage.komoditasJarakTempuh = this.jarakTempuh,
        localStorage.komoditasWaktuTempuh = this.waktuTempuh,
        localStorage.komoditasNilaiKomisi = this.nilaiKomisi,

        // Sistem
        localStorage.komoditasPesananPengirimanAktif = moment().format('DD-MM-YYYY');
        // localStorage.komoditasPesananPengiriman = 'true'

        window.getApp.$emit('APP_ULAS_PESANAN_PENGIRIMAN');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
